import { render, staticRenderFns } from "./seNews.vue?vue&type=template&id=04513904&"
import script from "./seNews.vue?vue&type=script&lang=js&"
export * from "./seNews.vue?vue&type=script&lang=js&"
import style0 from "./seNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports